// extracted by mini-css-extract-plugin
export default {"controlButtons":"controlButtons--dLN1frg9","light-white--button":"light-white--button--GZCGQPes"};